import { render } from "./ItemProduto.vue?vue&type=template&id=84de17b4&scoped=true"
import script from "./ItemProduto.vue?vue&type=script&lang=js"
export * from "./ItemProduto.vue?vue&type=script&lang=js"

import "./ItemProduto.vue?vue&type=style&index=0&id=84de17b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84de17b4"]])

export default __exports__